import { FormControls } from '@elementary/common-ui/components';
import { pluralizeString } from '@elementary/common-ui/utils/common';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';

const anomalyDirectionMap: Record<string, string> = {
  DROP: 'only drops',
  SPIKE: 'only spikes',
  BOTH: 'spikes and drops',
};

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const TablesPipelineTaskPerformanceCloudConfig = ({ watch }: Props) => (
  <>
    {!watch('anomalyConfig.fixedThreshold') && (
      <>
        <FormControls.FormText>
          Anomaly detection - automatically detect unusual task durations with a
          sensitivity level of <b>{watch('anomalyConfig.sensitivity')}</b>.
        </FormControls.FormText>

        {watch('anomalyConfig.anomalyDirection') && (
          <FormControls.FormText>
            Detect{' '}
            <b>
              {
                anomalyDirectionMap[
                  watch('anomalyConfig.anomalyDirection') || 'BOTH'
                ]
              }
            </b>{' '}
            in task duration.
          </FormControls.FormText>
        )}

        {watch('anomalyConfig.trainingPeriod') && (
          <FormControls.FormText>
            Training period:{' '}
            <b>
              {pluralizeString(
                watch('anomalyConfig.trainingPeriod.count') || 1,
                watch('anomalyConfig.trainingPeriod.period') || 'day',
                `${watch('anomalyConfig.trainingPeriod.period') || 'day'}s`,
              )}
            </b>
            .
          </FormControls.FormText>
        )}
      </>
    )}

    {watch('anomalyConfig.fixedThreshold') && (
      <FormControls.FormText>
        Static threshold - alert when task duration exceeds{' '}
        <b>
          {pluralizeString(
            watch('anomalyConfig.fixedThreshold.count') || 1,
            watch('anomalyConfig.fixedThreshold.period') || 'hour',
            `${watch('anomalyConfig.fixedThreshold.period') || 'hour'}s`,
          )}
        </b>
        .
      </FormControls.FormText>
    )}

    <SeverityRenderer severity={watch('severity')?.type || 'warn'} />
  </>
);

export default TablesPipelineTaskPerformanceCloudConfig;
